import type { User } from "firebase/auth";
import { resolveGmAccess } from "@/auth/gm-access";

export type GameAccessMode = "player" | "gm";

const STORAGE_PREFIX = "mind-survival/game-mode/v1";

function storageKey(userId: string): string {
  return `${STORAGE_PREFIX}:${userId}`;
}

/** Accounts allowed to switch into GM mode (owner + allowlist + claims). */
export function userCanAccessGmMode(
  user: User,
  claims?: Record<string, unknown> | null,
): boolean {
  return resolveGmAccess(user, claims).canUseInGameGmMode;
}

export function loadGameAccessMode(userId: string, canGm: boolean): GameAccessMode {
  if (!canGm) return "player";
  const raw = sessionStorage.getItem(storageKey(userId));
  return raw === "gm" ? "gm" : "player";
}

export function saveGameAccessMode(userId: string, mode: GameAccessMode): void {
  sessionStorage.setItem(storageKey(userId), mode);
}

export const GAME_MODE_LABEL: Record<GameAccessMode, string> = {
  player: "ผู้เล่น",
  gm: "GM",
};
